import { useTranslation, Trans } from "react-i18next";
import IconAlertCircleLinear from "@/assets/icons/info-circle.svg?react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog.tsx";
import { calculateProgressPercentage, formatNumber } from "@/shared/utils";
import IconDonLinear from "@/assets/icons/don-linear.svg?react";
import IconClose from "@/assets/icons/close.svg?react";
import { useCallback, useMemo, useState } from "react";
import CommonInfoLink from "@/components/common/CommonInfoLink";
import { DonReturnedSoonInfo } from "../../Single";

interface ModalShareChallengeProps {
  targetDon: number | string;
  gainedDon: number | string;
}

export default function ModalChallengeCancelled(
  props: ModalShareChallengeProps
) {
  const { gainedDon, targetDon } = props;
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleOpenChange = useCallback((value: boolean) => {
    setIsOpen(value);
  }, []);

  const progressBar = useMemo(() => {
    return calculateProgressPercentage(
      targetDon.toString(),
      gainedDon.toString()
    );
  }, [targetDon, gainedDon]);

  const leftDon = useMemo(() => {
    return Math.max(
      parseFloat(targetDon.toString()) - parseFloat(gainedDon.toString()),
      0
    );
  }, [targetDon, gainedDon]);

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <div>
          <CommonInfoLink
            className="mt-2.5 justify-between cursor-pointer"
            text={t("why_did_the_challenge_fail")}
            icon={
              <IconAlertCircleLinear
                className="shrink-0"
                width="20"
                height="20"
              />
            }
            onClick={handleOpen}
          />
        </div>
      </DialogTrigger>
      <DialogContent className="p-4 bg-gray-linear rounded-20 max-w-[85vw]  after:pointer-events-none after:z-0 after:absolute after:inset-0 after:border-2 after:border-white/08 after:rounded-20 border-none">
        <DialogClose className="absolute right-4 top-4">
          <IconClose />
        </DialogClose>
        <img
          className="absolute left-1/2 -translate-x-1/2 top-0 -translate-y-1/2 w-[130px] aspect-square pointer-events-none z-10"
          src="images/don-secondary.png"
          alt=""
        />
        <div className="relative z-10 flex flex-col items-center mt-10">
          <DialogTitle className="flex-center gap-1 text-center text-[28px] text-white leading-130 font-extrabold uppercase self-stretch mb-1">
            <IconDonLinear width="24" height="24" className="text-white" />
            {formatNumber(leftDon)}
          </DialogTitle>
          <div className="h-2 w-full rounded-lg bg-white/08 self-stretch my-3">
            <div
              className={`h-full w-full rounded-lg bg-blue`}
              style={{ width: `${progressBar}%` }}
            ></div>
          </div>
          <div>
            <p className="text-center text-white/80 font-normal leading-130 text-xs">
              <Trans
                i18nKey="why_the_challenge_failed"
                values={{ don: formatNumber(leftDon) }}
                components={{
                  bold: <span className="font-bold tracking-wide" />,
                }}
              />
            </p>
          </div>
          <hr className="border-none bg-white/08 h-px w-full my-4" />
          <DonReturnedSoonInfo className="w-full" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
